import { SidebarProps } from '@branch-messenger/willow-ui'
import { create } from 'zustand'

type DetailSidebarProps = SidebarProps & {
  id?: string
}

type DetailSidebarState = {
  detailSidebarProps: DetailSidebarProps
  openDetailSidebar: (props: DetailSidebarProps) => void
  closeDetailSidebar: () => void
}

export const useDetailSidebarStore = create<DetailSidebarState>(set => ({
  detailSidebarProps: {
    open: false,
  },
  openDetailSidebar: (props: DetailSidebarProps) =>
    set({ detailSidebarProps: { ...props, open: true } }),
  closeDetailSidebar: () =>
    set({
      detailSidebarProps: { open: false },
    }),
}))
